<script setup lang="ts">
import type { CmsBadge } from '@mop/cms/types';

defineOptions({
  name: 'UiCmsBadge',
});

defineProps({
  data: {
    type: Object as PropType<CmsBadge>,
    required: true,
  },
});
</script>

<template>
  <Ui2Badge :appearance="data.appearance" :size="data.size" class="ui-cms-badge">
    <Ui2Icon v-if="data.icon" :name="data.icon" :width="16" :height="16" class="ui-cms-badge__icon" />
    {{ data.label }}
  </Ui2Badge>
</template>

<style lang="scss" scoped>
.ui-cms-badge__icon {
  vertical-align: middle;
  margin-bottom: 2px;
}
</style>
